// Vendor Libs
import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {map, now} from 'lodash';
import {formatDuration} from '../../lib/core/date';

// Components
import Permissions from '../core/permissions';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import TableWithSort from '../core/table-with-sort';

function UserLocks({mediaItems}) {
    const [, setState] = useState();
    const interval = useRef();

    useEffect(() => {
        interval.current = setInterval(tick, 1000);

        return () => {
            clearInterval(interval.current);
        };
    }, []);

    const tick = () => {
        setState({});
    };

    const getColumnConfig = () => [
        {
            dataKey: 'guid',
            link: '/media-items',
            linkKey: 'guid',
            title: 'GUID',
            type: 'link',
            width: '40%',
        },
        {
            dataKey: 'username',
            title: 'User',
            width: '18%',
        },
        {
            dataKey: 'timestamp',
            formatter: 'timestamp',
            title: 'Timestamp',
            width: '30%',
        },
        {
            dataKey: 'duration',
            title: 'Duration',
            width: '12%',
        },
    ];

    const getRecordLockingData = () =>
        map(mediaItems, (record) => ({
            ...record,
            guid: record.recordId,
            duration: formatDuration((now() - parseInt(record.timestamp)) / 1000) || '0s',
        }));

    const getTablewithsortProps = () => ({
        activeRowKeys: ['guid'],
        columnConfig: getColumnConfig(),
        expandable: false,
        mediaItems,
        noSort: true,
        searchData: getRecordLockingData(),
    });

    return (
        <Permissions adminOnly={true} notAuthorizedMessage={true}>
            <div className="user-locks">
                <ServicesExportPanelAction exportConfig="recordLocking" searchData={getRecordLockingData()} />
                <TableWithSort {...getTablewithsortProps()} />
            </div>
        </Permissions>
    );
}

UserLocks.propTypes = {
    mediaItems: PropTypes.array,
};

const mapStateToProps = ({
    recordLocking: {lockedRecords: {mediaItems = []} = {}} = {},
    router: {routerParams = {}} = {},
}) => ({
    mediaItems,
    routerParams,
});

export default connect(mapStateToProps, null)(UserLocks);
